import React, { useEffect, useState } from "react";
import styled from "styled-components";
import HorizontalTabs from "sushiweb/HorizontalTabs";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as DeliveryDriversActions from "./../../../store/actions/DeliveryDrivers";
import * as UserActions from "./../../../store/actions/User";
import DriverBasicDetails from "../../../components/DeliveryDrivers/DriverBasicDetails";
import TopActionBar from "../../../components/DeliveryDrivers/TopActionBar";
import ErrorMsgs from "../../../constants/Errors.json";
import { capitalizeFirstLetter, getPath } from "../../../utils";
import DriverDocumentsDetail, {
  requiredDocs,
} from "../../../components/DeliveryDrivers/DriverDocumentsDetail";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import DriverAdditionalDetails from "../../../components/DeliveryDrivers/DriverAdditionalDetails";
import DriverAssetDetails from "../../../components/DeliveryDrivers/DriverAssetDetails";
import DriverServicesDetails from "../../../components/DeliveryDrivers/DriverServicesDetails";
import DriverReservationDetails from "../../../components/DeliveryDrivers/DriverReservationDetails";
import DriverLocalitiesDetails from "../../../components/DeliveryDrivers/DriverLocalitiesDetails";
import DriverFinancialDetails from "../../../components/DeliveryDrivers/DriverFinancialDetails";
import DriverLogsDetails from "../../../components/DeliveryDrivers/DriverLogsDetails";
import DriverStoreMappingDetails from "../../../components/DeliveryDrivers/DriverStoreMappingDetails";
import AssignmentStatus from "../../../components/DeliveryDrivers/AssignmentStatus";
import DriverMigrationDetails from "../../../components/DeliveryDrivers/DriverMigrationDetails";

const DeliveryDriversDetail = ({
  getDriverBasicDetails,
  driverBasicDetails,
  setStatus,
  getDriverDocuments,
  driverDocuments,
  driverDocumentId,
  allMenuActions,
}) => {
  const { id, detailType } = useParams();
  const allActions = MenuActionsMappings[MenuNames.DRIVER];
  const history = useHistory();
  const [activeIndex, setActiveIndex] = useState("");
  const [saveState, setSaveState] = useState(false);
  const [activeDriverLifecycleStatus, setActiveDriverLifecycleStatus] =
    useState("");
  const [editState, setEditState] = useState(false);
  const detailTabs = [
    "Details",
    "Additional details",
    "Financial",
    "Assets",
    "Services",
    "Localities",
    "Stores",
    "Reservations",
    "Logs",
    "Documents",
    "Assignment status",
    "Migration details"
  ];
  const hasPermission = (tab) => {
    switch (tab) {
      case "Details":
      case "Assets":
      case "Reservations":
      case "Stores":
      case "Migration details":
      case "Logs":
        return allMenuActions.DRIVER_DETAILS_VIEW;
      case "Additional details":
        return allMenuActions.DRIVER_ADDITIONAL_DETAILS_VIEW;
      case "Assignment status":
        return allMenuActions.DRIVER_ASSIGNMENT_STATUS_VIEW;
      case "Financial":
        return allMenuActions.DRIVER_FINANCIAL_DETAILS_VIEW;
      case "Services":
        return allMenuActions.DRIVER_SERVICES_DETAILS_VIEW;
      case "Localities":
        return allMenuActions.DRIVER_LOCALITIES_DETAILS_VIEW;
      case "Documents":
        return allMenuActions.DRIVER_DOCUMENTS_VIEW;
      default:
        return true;
    }
  };

  const handleClick = (tabName) => (e) => {
    setSaveState(false);
    // setActiveIndex(tabName);
    history.push(
      `/delivery-drivers/${id}/${tabName.split(" ").join("-").toLowerCase()}`
    );
  };

  const handleBackClick = () => {
    history.push("/delivery-drivers");
  };

  const handleDocumentDetails = () => {
    window.open(
      window.location.origin + `/delivery-drivers/${id}/documents`,
      "_blank"
    );
  };

  const getActiveComponent = () => {
    switch (activeIndex) {
      case "Details":
        return (
          <DriverBasicDetails
            details={driverBasicDetails}
            activeLifecycleStatus={activeDriverLifecycleStatus}
            editState={editState}
            saveState={saveState}
            setSaveState={setSaveState}
            driverDocuments={driverDocuments}
            handleDocumentDetails={handleDocumentDetails}
          />
        );
      case "Additional details":
        return (
          <DriverAdditionalDetails
            editState={editState}
            saveState={saveState}
            setSaveState={setSaveState}
          />
        );
      case "Assignment status":
        return (
          <AssignmentStatus
            editState={editState}
            saveState={saveState}
            setSaveState={setSaveState}
            handleAfterSave={handleEditCancel}
          />
        );
      case "Financial":
        return (
          <DriverFinancialDetails
            editState={editState}
            saveState={saveState}
            setSaveState={setSaveState}
          />
        );
      case "Assets":
        return <DriverAssetDetails />;
      case "Stores":
        return <DriverStoreMappingDetails />;
      case "Services":
        return (
          <DriverServicesDetails
            editState={editState}
            saveState={saveState}
            setSaveState={setSaveState}
          />
        );
      case "Localities":
        return (
          <DriverLocalitiesDetails
            editState={editState}
            saveState={saveState}
            setSaveState={setSaveState}
          />
        );
      case "Reservations":
        return <DriverReservationDetails />;
      case "Logs":
        return <DriverLogsDetails />;
      case "Documents":
        return (
          <DriverDocumentsDetail
            documents={driverDocuments}
            editState={editState}
            saveState={saveState}
            setSaveState={setSaveState}
            handleAfterSave={handleEditCancel}
          />
        );
      case "Migration details":
        return <DriverMigrationDetails />;
    }
  };

  const handleEditClick = () => {
    setEditState(true);
  };

  const handleEditCancel = () => {
    setEditState(false);
  };

  const handleSaveClick = (e) => {
    e.preventDefault();
    setSaveState(true);
  };

  useEffect(() => {
    setActiveIndex(capitalizeFirstLetter(detailType.split("-").join(" ")));
  }, [detailType]);

  useEffect(() => {
    getDriverBasicDetails(id).then((res) => {
      if (res) {
        const status = getPath(res, "basic_details.lifecycle_status", "");
        setActiveDriverLifecycleStatus(status);
        if (status === "terminated") {
          setStatus({
            type: "error",
            message: ErrorMsgs.DRIVER_ALREADY_TERMINATED,
          });
        }
      }
    });
    hasPermission("Documents") &&
      getDriverDocuments(id, { documents: requiredDocs });
  }, []);

  return (
    <DriverDetailsComponent>
      <TopActionBar
        handleSaveClick={handleSaveClick}
        handleEditCancel={handleEditCancel}
        editState={editState}
        handleEditClick={handleEditClick}
        handleBackClick={handleBackClick}
        driverDetails={driverBasicDetails}
        driverDocuments={driverDocuments}
        activeLifecycleStatus={activeDriverLifecycleStatus}
        activeIndex={activeIndex}
        allMenuActions={allMenuActions}
      />
      <HorizontalTabs id="sushi-tabs" className="mb-20" alignLinks="left">
        {detailTabs.map((tab, index) => {
          return hasPermission(tab) ? (
            <HorizontalTabs.Link
              active={activeIndex == tab}
              onClick={handleClick(tab)}
              key={index}
              className={`tab${index}${activeIndex === tab}`}
            >
              {tab}
            </HorizontalTabs.Link>
          ) : (
            <span />
          );
        })}
      </HorizontalTabs>
      {getActiveComponent()}
    </DriverDetailsComponent>
  );
};

const DriverDetailsComponent = styled.section`
  i {
    cursor: pointer;
  }
`;

function mapStateToProps(state) {
  const { DeliveryDrivers, MenuActions } = state;
  return {
    driverBasicDetails: DeliveryDrivers.driverBasicDetails,
    driverDocuments: DeliveryDrivers.driverDocuments,
    driverDocumentId: DeliveryDrivers.driverDocumentId,
    allMenuActions: MenuActions.allMenuActions,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDriverBasicDetails: bindActionCreators(
      DeliveryDriversActions.getDriverBasicDetails,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    getDriverDocuments: bindActionCreators(
      DeliveryDriversActions.getDriverDocuments,
      dispatch
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeliveryDriversDetail);
